import { render, staticRenderFns } from "./action.vue?vue&type=template&id=46d1d0a8&scoped=true"
import script from "./action.ts?vue&type=script&lang=ts&external"
export * from "./action.ts?vue&type=script&lang=ts&external"
import style0 from "./action.less?vue&type=style&index=0&id=46d1d0a8&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d1d0a8",
  null
  
)

export default component.exports